class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener('input', this.onInputChange.bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
    window.addEventListener('resize', this.adjustResultsPosition.bind(this));
  }

  onInputChange(event) {
    const searchTerm = event.target.value.trim();

    if (searchTerm.length < 2) {
      this.clearResults();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFocus(event) {
    const searchTerm = event.target.value.trim();
    if (searchTerm.length >= 2) {
      this.getSearchResults(searchTerm);
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) {
      this.clearResults();
    }
  }

  getSearchResults(searchTerm) {
    this.showLoading();

    fetch(`${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=15&section_id=predictive-search`)
      .then(response => response.json())
      .then(data => {
        if (data.resources.results.products && data.resources.results.products.length > 0) {
          this.renderSearchResults(data.resources.results.products, searchTerm);
        } else {
          this.showNoResults(searchTerm);
        }
      })
      .catch(() => {
        this.showError();
      });
  }

  

  renderSearchResults(products, searchTerm) {
    const resultsHtml = `
      <h2 class="predictive-search__title"> </h2>
      <div class="predictive-search__results-grid">
        ${products.map(product => `
          <div class="predictive-search__grid-item">
            <a href="${product.url}" class="predictive-search-item">
              ${product.featured_image ? `
              <div class="predictive-search-item-image">
                <img src="${product.featured_image.url}" 
                     alt="${product.featured_image.alt || ''}" 
                     loading="lazy">
              </div>
              ` : ''}
            </a>
          </div>
        `).join('')}
      </div>
      <div class="predictive-search__more-results">
        <a href="/search?q=${encodeURIComponent(searchTerm)}" class="predictive-search__more-results-button">+</a>
      </div>
    `;

    this.predictiveSearchResults.innerHTML = resultsHtml;
    this.showResults();
  }

  showLoading() {
    this.predictiveSearchResults.innerHTML = `
      <div class="predictive-search__loading-state">
        <svg aria-hidden="true" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </div>
    `;
    this.showResults();
  }

  showNoResults(searchTerm) {
    this.predictiveSearchResults.innerHTML = `
      <div class="predictive-search__no-results">
        <p>⚠️</p>
      </div>
    `;
    this.showResults();
  }

  showError() {
    this.predictiveSearchResults.innerHTML = `
      <div class="predictive-search__error">
        <p>🔄</p>
      </div>
    `;
    this.showResults();
  }

  showResults() {
    this.predictiveSearchResults.style.display = 'block';
    this.adjustResultsPosition();
  }

  clearResults() {
    this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.innerHTML = '';
  }

  adjustResultsPosition() {
    if (window.innerWidth < 768) {
      this.predictiveSearchResults.style.width = '100%';
      this.predictiveSearchResults.style.left = '0';
    } else {
      this.predictiveSearchResults.style.width = '';
      this.predictiveSearchResults.style.left = '';
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);